__turbopack_context__.v({
  "aspectBox": "BlockSharpnessStory-module-scss-module__nW9DRG__aspectBox",
  "block": "BlockSharpnessStory-module-scss-module__nW9DRG__block",
  "content": "BlockSharpnessStory-module-scss-module__nW9DRG__content",
  "cta": "BlockSharpnessStory-module-scss-module__nW9DRG__cta",
  "eyebrow": "BlockSharpnessStory-module-scss-module__nW9DRG__eyebrow",
  "fade-in": "BlockSharpnessStory-module-scss-module__nW9DRG__fade-in",
  "flushBottom": "BlockSharpnessStory-module-scss-module__nW9DRG__flushBottom",
  "flushTop": "BlockSharpnessStory-module-scss-module__nW9DRG__flushTop",
  "image": "BlockSharpnessStory-module-scss-module__nW9DRG__image",
  "inlineImage": "BlockSharpnessStory-module-scss-module__nW9DRG__inlineImage",
  "inner": "BlockSharpnessStory-module-scss-module__nW9DRG__inner",
  "innerAspect": "BlockSharpnessStory-module-scss-module__nW9DRG__innerAspect",
  "innerContent": "BlockSharpnessStory-module-scss-module__nW9DRG__innerContent",
  "isReveal": "BlockSharpnessStory-module-scss-module__nW9DRG__isReveal",
  "overlay": "BlockSharpnessStory-module-scss-module__nW9DRG__overlay",
  "overlayCloseButton": "BlockSharpnessStory-module-scss-module__nW9DRG__overlayCloseButton",
  "richCopyWrapper": "BlockSharpnessStory-module-scss-module__nW9DRG__richCopyWrapper",
  "root": "BlockSharpnessStory-module-scss-module__nW9DRG__root",
  "theme--makers-reserve": "BlockSharpnessStory-module-scss-module__nW9DRG__theme--makers-reserve",
});
